var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"card-content"},[_vm._t("top"),(_vm.container)?_c('b-container',[_vm._t("contentt")],2):_c('div',[_vm._t("contentt")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }